import React from "react";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import MainHeader from "./MainHeader/MainHeader";
import { useWindowWidth } from "../hooks/useWindowWidth";

export type AppLayoutProps = {
  theme: string;
  toggleTheme: () => void;
};

const AppLayout: React.FC<AppLayoutProps> = ({ theme, toggleTheme }) => {
  const { isMdScreen } = useWindowWidth();
  const location = useLocation();
  const transparentRoutes = ["/"];
  const isTransparent = transparentRoutes.some(
    // we disable transparent on mobile
    (path) => path === location.pathname && isMdScreen,
  );

  return (
    <div className="relative min-h-screen">
      {/* Background Logo Watermark */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div
          className="absolute inset-0 bg-no-repeat bg-center bg-contain opacity-[0.15]"
          style={{
            backgroundImage: "url('/logo_dhi.png')",
            backgroundSize: "40%",
            backgroundPosition: "center center",
          }}
        ></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10">
        <MainHeader
          backgroundColorRGB="32, 77, 132"
          transparent={isTransparent}
          theme={theme}
          toggleTheme={toggleTheme}
        />
        <Outlet /> {/* This will render the matched child route component. */}
      </div>
    </div>
  );
};

export default AppLayout;
